import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Form,
  Col,
  Input,
  Checkbox,
  Switch,
} from 'antd';

import Bloco from '../../../components/Bloco';

export function CadastroStatus() {
  const history = useHistory();
  const [formCadastroStatus] = Form.useForm();
  const [statusSwitch, setStatusSwitch] = useState(false);
  const [manifestar, setManifestar] = useState();

  const prepararPayload = () => {
    // const dadosBasicos = formCadastroStatus.getFieldsValue();
  };

  return (
    <Bloco>
        <Form.Provider>
          <Form
            form={formCadastroStatus}
            layout="vertical"
            name="formCadastroStatus"
            size="large"
            onFinish={prepararPayload}
          >
            <Col xs={24} sm={24} md={3} lg={3} xl={3}>
              <Form.Item name="id" label="ID">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="descricao" label="Descrição">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="manifestar">
                <Checkbox
                  onChange={e => setManifestar(e.target.checked)}
                  checked={manifestar}
                >
                  Permitir Manifestar
                </Checkbox>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="status" label="Status">
                <Switch
                  style={{
                    background: statusSwitch ? '#000D54' : '#D9D9D9',
                  }}
                  checked={statusSwitch}
                  onChange={setStatusSwitch}
                  defaultChecked
                />
              </Form.Item>
            </Col>
            <Col
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
              }}
            >
              <Form.Item>
                <Button
                  style={{
                    backgroundColor: '#0D364A',
                    color: '#FFFFFF',
                    fontSize: 18,
                    height: 43,
                    width: 143,
                    marginRight: 40,
                  }}
                  type="default"
                  onClick={() => history.push('/status-gr')}
                >
                  Cancelar
                </Button>
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    backgroundColor: '#0D364A',
                    color: '#FFFFFF',
                    fontSize: 18,
                    height: 43,
                    width: 143,
                  }}
                >
                  Salvar
                </Button>
              </Form.Item>
            </Col>
          </Form>
        </Form.Provider>
    </Bloco>
  );
}
